import {
  Box,
  FormControl,
  FormLabel,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';

import CopyableCode from '@/components/shared/copyableCode';
import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';

import type { SetupOwnCloudState } from './SetupOwnCloudFlow';
import { BulletItem } from './bulletItem';
import { FormTextField } from './formTextField';

export const ConnectSourceAccount = (props: StepProps<SetupOwnCloudState>) => {
  const eon_backup_app_id = 'var.eon_backup_app_id';
  const customer_backup_app_id = 'var.customer_backup_app_id';
  const subscription_id = 'var.subscription_id';
  const management_group_id = 'var.management_group_id';

  const code = `\
module "azure_source" {
  source = "https://eon.blob.core.windows.net/public/onboarding/v1.1.2/terraform/source.zip"

  eon_backup_app_id      = ${eon_backup_app_id}
  customer_backup_app_id = ${customer_backup_app_id}
  subscription_id        = ${subscription_id}
  management_group_id    = ${management_group_id}
}`;

  return (
    <StepContainer
      stepperIndex={3}
      stepperLabels={props.stepperLabels}
      canGoNext={() =>
        props.wizardState.connectType === 'subscription'
          ? !!props.wizardState.sourceSubscriptionId
          : !!props.wizardState.sourceManagementGroupId
      }
      nextButtonText={'Connect & Continue'}
      sx={{ overflow: 'auto' }}
      onNextClick={async () => {
        props.setNextStep(props.currentStep.next?.[0]);
      }}
    >
      <Box paddingX='min(100px,6vw)' width='100%' height='100%'>
        <BulletItem
          title='Fill in the details to generate your Terraform module, then review and deploy it in your environment.'
          leftContent={
            <Stack gap='24px'>
              <FormControl>
                <FormLabel>
                  <Typography variant='subtitle1'>
                    What do you want to connect?
                  </Typography>
                </FormLabel>
                <ToggleButtonGroup
                  sx={{ width: 'max-content' }}
                  exclusive
                  value={props.wizardState.connectType}
                  onChange={(_, value) =>
                    props.setWizardState({
                      ...props.wizardState,
                      connectType: value,
                    })
                  }
                >
                  <ToggleButton value='subscription'>Subscription</ToggleButton>
                  <ToggleButton value='managementGroup'>
                    Management group
                  </ToggleButton>
                </ToggleButtonGroup>
              </FormControl>
              {props.wizardState.connectType === 'subscription' && (
                <FormTextField
                  title='Subscription ID'
                  placeholder='Example: 12345678-90ab-cdef-1234-567890abcdef'
                  value={props.wizardState.sourceSubscriptionId || ''}
                  onChange={(event) =>
                    props.setWizardState({
                      ...props.wizardState,
                      sourceSubscriptionId: event.target.value,
                    })
                  }
                />
              )}
              {props.wizardState.connectType === 'managementGroup' && (
                <FormTextField
                  title='Management group ID'
                  placeholder='Example: 12345678-90ab-cdef-1234-567890abcdef'
                  value={props.wizardState.sourceManagementGroupId || ''}
                  onChange={(event) =>
                    props.setWizardState({
                      ...props.wizardState,
                      sourceManagementGroupId: event.target.value,
                    })
                  }
                />
              )}
            </Stack>
          }
          rightContent={<CopyableCode title='main.tf' code={code} />}
        />
      </Box>
    </StepContainer>
  );
};
